import type { ReactNode } from "react";
import styles from "./instanceDetail.module.css";

// Responsive grid the panels drop into. Adding a panel is one <ChartCard>
// child here - no layout change. Cards mark themselves `wide` to span the row.
export const InstancePanelGrid = ({ children }: { children: ReactNode }): JSX.Element => (
  <div className={styles.panelGrid}>{children}</div>
);

// Locks two cards onto one full-width row of the grid, so related series
// stay horizontally comparable instead of drifting apart as the auto-fit
// column count changes with viewport width.
export const PanelPair = ({ children }: { children: ReactNode }): JSX.Element => (
  <div className={styles.panelPair}>{children}</div>
);
